export enum FontCategory {
    'Sans' = 0,
    'Serif' = 1,
    'Symbol' = 2,
    'Slab Serif' = 3,
    'Wacky' = 4,
    'Script' = 5,
    'Decorative' = 6,
}

export function isFontCategory(value: unknown): value is FontCategory {
    return typeof value === 'number' && value in FontCategory;
}

export const FONT_CATEGORIES =
    Object.values(FontCategory).filter(isFontCategory);

export const FONT_CATEGORY_OPTIONS = FONT_CATEGORIES.map((value) => ({
    value,
    label: FontCategory[value],
}));
